(function () {
  'use strict';

  function parseVideo(item) {
    if (!item || typeof item !== 'object' || !/^\d+$/.test(String(item.id || ''))) return null;
    if (item.vimeo_uri && item.vimeo_uri !== '/videos/' + String(item.id)) return null;

    try {
      var share = new URL(item.share_url);
      if (share.protocol !== 'https:' || share.hostname !== 'vimeo.com' || share.port) return null;
      var parts = share.pathname.split('/').filter(Boolean);
      if (!parts.length || parts[0] !== String(item.id) || parts.length > 2) return null;
      var pathHash = parts[1] || '';
      var queryHash = share.searchParams.get('h') || '';
      var declaredHash = item.hash || '';
      if ((pathHash && !/^[A-Za-z0-9]+$/.test(pathHash)) || (queryHash && !/^[A-Za-z0-9]+$/.test(queryHash)) || (declaredHash && !/^[A-Za-z0-9]+$/.test(declaredHash))) return null;
      if (pathHash && queryHash && pathHash !== queryHash) return null;
      if (declaredHash && ((pathHash && declaredHash !== pathHash) || (queryHash && declaredHash !== queryHash))) return null;
      var hash = declaredHash || pathHash || queryHash;
      var src = 'https://player.vimeo.com/video/' + String(item.id) + (hash ? '?h=' + encodeURIComponent(hash) + '&' : '?') + 'dnt=1&playsinline=1';
      return { shareUrl: share.href, embedBase: src };
    } catch (error) {
      return null;
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var components = [];
    if (scope.matches && scope.matches('[data-ffpv-root]')) components.push(scope);
    components = components.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-ffpv-root]')));

    components.forEach(function (component) {
      if (component.dataset.ffpvReady === '1') return;
      component.dataset.ffpvReady = '1';

      var data;
      try { data = JSON.parse(component.dataset.videos || '{}'); } catch (error) { return; }
      if (!data || !Array.isArray(data.videos) || !data.videos.length) return;

      var videos = data.videos.map(function (item) {
        var safe = parseVideo(item);
        return safe ? Object.assign({}, item, { _safe: safe }) : null;
      });
      var valid = videos.map(function (video, index) { return video ? index : -1; }).filter(function (index) { return index >= 0; });
      if (!valid.length) return;

      var activeIndex = valid.find(function (index) { return String(videos[index].id) === String(data.primary_video_id || ''); });
      if (activeIndex === undefined) activeIndex = valid.find(function (index) { return videos[index].role === 'showcase'; });
      if (activeIndex === undefined) activeIndex = valid[0];

      var player = component.querySelector('[data-ffpv-player]');
      var poster = component.querySelector('[data-ffpv-play]');
      var frame = component.querySelector('[data-ffpv-frame]');
      var playLabel = component.querySelector('[data-ffpv-play-label]');
      var status = component.querySelector('[data-ffpv-status]');
      var fallback = component.querySelector('[data-ffpv-fallback]');
      var playerMessageHandler = null;
      var readyTimer = null;
      if (!player || !poster || !frame) return;

      function clearPlayerWatchers() {
        if (playerMessageHandler) window.removeEventListener('message', playerMessageHandler);
        if (readyTimer) window.clearTimeout(readyTimer);
        playerMessageHandler = null;
        readyTimer = null;
      }

      function choose(index) {
        if (!videos[index] || !videos[index]._safe) return;
        clearPlayerWatchers();
        activeIndex = index;
        frame.replaceChildren();
        poster.hidden = false;
        component.querySelectorAll('[data-ffpv-choice]').forEach(function (button) {
          var selected = Number(button.dataset.ffpvChoice) === activeIndex;
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var video = videos[activeIndex];
        if (playLabel) playLabel.textContent = 'Play ' + (video.label || video.title || 'video');
        poster.setAttribute('aria-label', 'Play ' + (video.label || video.title || 'video'));
        if (fallback) {
          fallback.href = video._safe.shareUrl;
          fallback.textContent = 'Watch ' + (video.label || 'this video') + ' on Vimeo';
        }
        if (status) status.textContent = (video.label || video.title || 'Video') + ' selected.';
      }

      component.querySelectorAll('[data-ffpv-choice]').forEach(function (button) {
        button.addEventListener('click', function () { choose(Number(button.dataset.ffpvChoice)); });
      });

      poster.addEventListener('click', function () {
        var video = videos[activeIndex];
        if (!video || !video._safe) return;
        clearPlayerWatchers();
        frame.replaceChildren();
        var iframe = document.createElement('iframe');
        var embedUrl = new URL(video._safe.embedBase);
        embedUrl.searchParams.set('autoplay', '1');
        iframe.src = embedUrl.toString();
        iframe.title = (component.dataset.productTitle || 'Product') + ' — ' + (video.label || video.title || 'video');
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.appendChild(iframe);
        poster.hidden = true;
        if (status) status.textContent = 'Loading ' + (video.label || video.title || 'video') + '.';
        var settled = false;
        readyTimer = window.setTimeout(function () {
          if (!settled && status && iframe.isConnected) status.textContent = 'Video is taking longer to load. You can watch it on Vimeo.';
        }, 7000);
        playerMessageHandler = function (event) {
          if (event.origin !== 'https://player.vimeo.com' || event.source !== iframe.contentWindow || !iframe.isConnected) return;
          var payload = event.data;
          if (typeof payload === 'string') {
            try { payload = JSON.parse(payload); } catch (error) { return; }
          }
          if (!payload || typeof payload !== 'object') return;
          if (payload.event === 'ready' || payload.event === 'play') {
            settled = true;
            window.clearTimeout(readyTimer);
            readyTimer = null;
            if (status) status.textContent = (video.label || video.title || 'Video') + (payload.event === 'play' ? ' is playing.' : ' is ready.');
          }
        };
        window.addEventListener('message', playerMessageHandler);
        iframe.addEventListener('load', function () {
          if (!iframe.isConnected) return;
          try { iframe.contentWindow.postMessage({ method: 'addEventListener', value: 'ready' }, 'https://player.vimeo.com'); } catch (error) { /* cross-origin messaging is optional */ }
          try { iframe.contentWindow.postMessage({ method: 'addEventListener', value: 'play' }, 'https://player.vimeo.com'); } catch (error) { /* cross-origin messaging is optional */ }
        }, { once: true });
      });

      choose(activeIndex);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
